import { Layer } from "mapbox-gl";

export function getPathIdFromLayer(layer: Layer) {
  const arr = layer.id.split(".");

  if (arr.length > 1) return arr[1];

  return arr[0];
}
